<template>
    <div class="columns">
        <div class="column is-8 is-offset-2">
            <div class="has-text-centered">
                <h2 class="mb-2 is-size-4">🤖 {{ translate("page.category_manager.path_extract_rules_title") }}</h2>
                <p class="mb-3">{{ translate("page.category_manager.path_extract_rules_description") }}</p>
            </div>

            <!-- Processing State -->
            <ExtractionProcessing v-if="store.hasOngoingExtraction" />

            <ExtractionsListing v-else-if="store.extractions.length > 0 && !store.showNewExtractionForm" />

            <InitExtractionForm v-else />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";
    import InitExtractionForm from "./ExtractFromRules/InitExtractionForm.vue";
    import ExtractionsListing from "./ExtractFromRules/ExtractionsListing.vue";
    import ExtractionProcessing from "./ExtractFromRules/ExtractionProcessing.vue";

    const store = useCategoriesManagerStore();
</script>

<style scoped></style>
